import { Component } from 'react';
import { RotateCcw } from 'lucide-react';

// A crash inside one panel must not leave an empty area: show a short note with a retry instead.
export class PanelBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error('Panel error', error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="panel-failed" data-testid="panel-failed"><p>Hier ist etwas schiefgelaufen. Dein Design ist sicher.</p><button type="button" onClick={() => this.setState({ failed: false })} data-testid="panel-retry"><RotateCcw size={14} />Bereich neu laden</button></div>;
  }
}
